import React from "react";
import { withStyles, createStyles, WithStyles, Theme } from "@material-ui/core/styles";

import Grid from "../../lib/components/grid";
import Confirmation from "../../lib/components/confirmation";

import { Brand, brands, getBrandsFinYear } from "../../lib/api/brand";
import { GridColumns } from "./brandsgridsetup";

import Tooltip from "@material-ui/core/Tooltip";
import Button from "@material-ui/core/Button";

import IconAdd from "@material-ui/icons/Add";

import BrandsEditForm from "./brandseditform";
import { GenerateErrorMessage } from "../../lib/helpers/string_methods";
import { SnackContext } from "../../lib/context/SnackContext";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(1),
      width: "100%",
      height: "100%",
      position: "relative",
    },
    inline: {
      display: "inline",
      position: "absolute",
      marginTop: "7px",
      marginLeft: "7px",
    },
  });

type BrandsProps = {} & WithStyles<typeof styles>;

export class BrandsUnstyled extends React.Component<BrandsProps, any> {
  state = {
    classes: undefined,
    data: [],
    confirmRemoveID: undefined,
    confirmEditID: undefined,
    loading: true,
    brandsFinYear: [],
  };

  constructor(props) {
    super(props);
    this.state.classes = props.classes;
  }

  static contextType = SnackContext;
  context!: React.ContextType<typeof SnackContext>;

  componentDidMount() {
    this.loadData();
  }

  loadData = async () => {
    const [brandsData, brandsFinYear] = await Promise.all([brands.all(), getBrandsFinYear()]);
    const dataSorted = brandsData.sort((a, b) => a.code.localeCompare(b.code));
    this.setState({ loading: false, data: dataSorted, brandsFinYear });
  };

  handleCreate = () => {
    this.setState({ confirmEditID: "0" });
  };

  handleEdit = (id) => {
    this.setState({ confirmEditID: id });
  };

  handleEditClose = () => {
    this.setState({ confirmEditID: undefined });
  };

  handleEditConfirm = async (item: Brand) => {
    try {
      const id = item["id"];
      delete item["id"];

      if (!id || id.toString() == "0") {
        await brands.create({ data: { ...item } });
      } else {
        await brands.update(id, { data: { ...item } });
      }
    } catch (error) {
      const err = GenerateErrorMessage(error, "Error processing Brand.");
      this.context.updateSnack({ show: true, color: "red", message: err });
    }
    this.loadData();
    this.handleEditClose();
  };

  handleRemove = async (id) => {
    this.setState({ confirmRemoveID: id });
  };

  handleRemoveClose = () => {
    this.setState({ confirmRemoveID: undefined });
  };

  handleRemoveConfirm = async () => {
    await brands.remove(this.state.confirmRemoveID);
    this.handleRemoveClose();
    this.loadData();
  };

  GridColumnsOverride = (column, row) => {
    return GridColumns(column, row, this.handleRemove, this.handleEdit);
  };

  render() {
    const { classes } = this.state;

    return (
      <div className={classes.root}>
        <div className={classes.inline}>
          <Tooltip style={{ zIndex: 0 }} title="Create new Brand">
            <div className={classes.inline}>
              <Button variant="contained" color="primary" onClick={this.handleCreate} style={{ marginBottom: "10px" }}>
                <IconAdd />
              </Button>
            </div>
          </Tooltip>
        </div>
        <Grid loading={this.state.loading} data={this.state.data} GridColumns={this.GridColumnsOverride} clearFilters={"brandsgridsetup"} />
        {this.state.confirmRemoveID && (
          <Confirmation
            isOpen={this.state.confirmRemoveID ? true : false}
            handleClose={this.handleRemoveClose}
            handleConfirm={this.handleRemoveConfirm}
            title="Remove selected Brand?"
            body="Are you sure you want to REMOVE the selected Brand Record?"
          ></Confirmation>
        )}
        {this.state.confirmEditID && (
          <Confirmation
            isOpen={this.state.confirmEditID ? true : false}
            handleClose={this.handleEditClose}
            handleConfirm={() => {}}
            title={this.state.confirmEditID == "0" ? "Creating Brand" : "Editing Brand"}
            body={undefined}
          >
            <BrandsEditForm onSubmit={this.handleEditConfirm} onClose={this.handleEditClose} id={this.state.confirmEditID} brandsFinYear={this.state.brandsFinYear} />
          </Confirmation>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(BrandsUnstyled);
